module.exports = __webpack_public_path__ + "img/company_logo_small.040f39d9.jpg";